const topicsData = [
  { label: '暗夜追光结局解析', heat: '9.8万' },
  { label: '狂飙2026追剧日历', heat: '8.5万' },
  { label: '刘亦菲新剧口碑', heat: '7.2万' },
  { label: '仙侠剧天花板', heat: '6.8万' },
  { label: '暑期档排播表', heat: '6.3万' },
  { label: '国产悬疑推荐', heat: '5.9万' },
  { label: '古装服化道盘点', heat: '5.4万' },
  { label: '4K画质对比', heat: '4.8万' },
  { label: '追剧必备零食', heat: '4.2万' },
  { label: '演技名场面', heat: '3.9万' },
  { label: 'OST神曲盘点', heat: '3.5万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-hashtag"></i>
            社群热议
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-foreground-500 text-sm">追剧圈最热门的讨论话题，加入大家一起聊</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((item) => (
            <a
              key={item.label}
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200 hover:border-primary-200 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
                #{item.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200 group-hover:bg-primary-100 group-hover:text-primary-600 px-1.5 py-0.5 rounded-full transition-colors">
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}